// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import { post, redirect } from '../../utils/http';

type LoginResponse = {
  body: {
    code: string,
    state: string,
    redirect_uri: string,
  }
}

export const tryLogin = (
  signInUrl: string,
  username: string,
  password: string,
  urlBuilder: any => string,
): Promise<LoginResponse> => new Promise((resolve, reject) => {
  post(signInUrl, { username, password })
    .then((resp) => {
      redirect(urlBuilder(resp.body));
    })
    .catch((resp) => {
      const statusCode = resp && resp.response && resp.response.statusCode;
      const message = (
        resp
          && resp.response
          && resp.response.body
          && resp.response.body.error
          && resp.response.body.error.message
      ) || 'Unknown error';
      reject({ message, statusCode });
    });
});
